import React, { useState } from 'react';
import styles from './Footer.module.scss';
import logoDev from '../../Assets/images/logoPikcel2.svg';
import logo from '../../Assets/logo-nounou-chou-express.webp';
import Modal from '../Modal/Modal';
import SapBadge from '../SapBadge/SapBadge';
import MentionsLegales from '../MentionsLegales/MentionsLegales';

const Footer = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <footer id="footer" className={styles.footer}>
      <div className={styles.footerContent}>
        <div className={styles.footerLogo}>
          <a href="/" className={styles.logo}>
            <img src={logo} alt="Logo de l'entreprise" />
          </a>
          <SapBadge className={styles.sapBadge} />
        </div>
        <nav className={styles.footerNav}>
          <ul>
            <li><a href="#a-propos">À propos</a></li>
            <li><a href="#reservation-particuliers">Réservation particuliers</a></li>
            <li><a href="#contrat-longue-duree">Longue durée</a></li>
            <li><a href="#cmg">CMG</a></li>
            <li><a href="#entreprises-sap">Entreprises SAP</a></li>
            <li><a href="#footer">Contact</a></li>
          </ul>
        </nav>
        <div className={styles.footerContact}>
          <p>Contactez-nous : <a href="tel:0664953123">06 64 95 31 23</a></p>
          <p>Email : <a href="mailto:nounou.chou95@hotmail.com">nounou.chou95@hotmail.com</a></p>
        </div>
        <div className={styles.legalMentions}>
          <h3>Mentions Légales</h3>
          <p>
            Pour plus d'informations sur nos conditions d'utilisation et notre
            politique de confidentialité, veuillez consulter nos mentions légales.
          </p>
          <p>
            <a href="#mentions-legales" onClick={openModal}>Voir les mentions légales</a>
            {' · '}
            <button
              type="button"
              className={styles.cookieLink}
              onClick={() => window.dispatchEvent(new Event('open-cookie-settings'))}
            >
              Personnaliser ses cookies
            </button>
          </p>
        </div>
      </div>
      <div className={styles.footerBottom}>
        <p>&copy; {new Date().getFullYear()} Nounou Chou Express. Tous droits réservés.</p>
        <div className={styles.devInfo}>
  <span className={styles.devText}>Site réalisé par </span>
  <a href="https://www.pikcel.fr" target="_blank" rel="noopener noreferrer">
    <img src={logoDev} alt="logo de l'agence Pikcel, agence web à Denain et Valenciennes, création de sites internet" className={styles.logoDev} />
  </a>
</div>


      </div>
      <Modal isOpen={isModalOpen} onClose={closeModal} wide>
        <MentionsLegales />
      </Modal>

    </footer>
  );
};

export default Footer;

